import { useCallback, useEffect } from "react"
import { postSubmit, formatDate } from "@ui-seeker/utils"
import { parseBackendDate } from "@utils"
import { useToast } from "@hooks"
import { isReportMultipleModalLoading, reportListMultipleData, setReportData } from "Pages/ReportsAlerts/Reports/@signals"
import { MULTIPLE_MODAL_LOADING } from "Pages/ReportsAlerts/Reports/@constants"
import { useReportBackendApiPath } from "Pages/ReportsAlerts/Reports/@hooks/index"

export default function useReportExecutionDatesMultiple() {

	const { showToast } = useToast()
	const { backendUrl } = useReportBackendApiPath()

	const submitData = useCallback(() => {
		postSubmit(`${backendUrl}/update-execution-dates-multi`, {
			idReport: reportListMultipleData.value.idReport,
			executionDateMin: reportListMultipleData.value.executionDateMin ? formatDate(parseBackendDate(reportListMultipleData.value.executionDateMin), { format: 'yyyy-MM-dd' }) : null,
			executionDateMax: reportListMultipleData.value.executionDateMax ? formatDate(parseBackendDate(reportListMultipleData.value.executionDateMax), { format: 'yyyy-MM-dd' }) : null,
		})
			.then(res => {
				res.map(e => setReportData(e))
				reportListMultipleData.value = { values: [], key: '', idReport: [], reportsInfo: [] }
				showToast.success("Successfully updated report")
				isReportMultipleModalLoading.value = null
			})
			.catch(() => {
				reportListMultipleData.value = { values: [], key: '', idReport: [], reportsInfo: [] }
				showToast.error("Error updating report")
				isReportMultipleModalLoading.value = null
			})
	}, [])

	useEffect(() => {
		if (isReportMultipleModalLoading.value === MULTIPLE_MODAL_LOADING.UPDATE_EXECUTION_DATES) submitData()
	}, [isReportMultipleModalLoading.value])

	return {
		executionDateMin: reportListMultipleData.value.executionDateMin,
		executionDateMax: reportListMultipleData.value.executionDateMax,
		setExecutionDateMin: value => {
			const currentMax = reportListMultipleData.value.executionDateMax
			const shouldResetMax = currentMax && value && new Date(value) > new Date(currentMax)
			reportListMultipleData.value = { ...reportListMultipleData.value, executionDateMin: value, ...(shouldResetMax && { executionDateMax: value }) }
		},
		setExecutionDateMax: value => reportListMultipleData.value = { ...reportListMultipleData.value, executionDateMax: value },
	}
}
